import { useApiAccountsV1SigninVerifyCreate } from 'api';
import { OtpForm, type OtpFormValues, OtpIcon, SignInPage, useNotification } from 'features';
import { safiLogo } from 'features/brand';
import { useTranslation } from 'i18n';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { getAuthRoute } from '../../utils/getAuthRoute';
import { redirectPostSignIn } from '../../utils/redirectPostSignIn';

export const SignInEmailVerify = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const { open } = useNotification();
  const { mutate, isPending } = useApiAccountsV1SigninVerifyCreate({
    mutation: {
      onError() {
        open({
          message: t('notifications.errorVerifyingPasscode'),
          type: 'error',
        });
      },
      onSuccess() {
        redirectPostSignIn();
      },
    },
  });

  const handleSubmit = (data: OtpFormValues) => {
    mutate({
      data: {
        verification_code: data.email_verification_code,
      },
    });
  };

  return (
    <SignInPage logo={safiLogo}>
      <OtpIcon variant="email" />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {t('signInVerify.welcomeBack')}
      </Typography>
      <Typography>{t('signInVerify.emailPasscodeHint', { values: { brandName: tCommon('brand.name') } })}</Typography>
      <OtpForm onSubmit={handleSubmit} isLoading={isPending} />
      <Link component={RouterLink} to={getAuthRoute('/sign-in/email')}>
        {t('shared.goBack')}
      </Link>
    </SignInPage>
  );
};
